import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { SITENAMEALIAS, WEBSERVICE, isTestMode } from "../utils/init";
import {
  showToast,
  showHttpError,
  currentPageAccess,
  showConfirm,
} from "../utils/library";
import axios from "axios";
import { sendOtpForTwoFa, getAuthToken, getAuthUuid } from "../utils/service";
import PageHeader from "../components/PageHeader";

const styles = {
  pageWrapper: {
    padding: "32px 24px 60px",
  },
  pageHeader: {
    marginBottom: "28px",
  },
  pageTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  pageSubtitle: {
    fontSize: "13px",
    opacity: 0.5,
    margin: "4px 0 0",
  },
  // Create API Card
  createCard: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
    marginBottom: "24px",
    overflow: "hidden",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "20px 24px",
    borderBottom:
      "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
  },
  cardHeaderIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "15px",
    flexShrink: 0,
  },
  iconGreen: {
    color: "#10b981",
    background: "color-mix(in srgb, #10b981, transparent 88%)",
  },
  iconBlue: {
    color: "#3b82f6",
    background: "color-mix(in srgb, #3b82f6, transparent 88%)",
  },
  iconPurple: {
    color: "#7c3aed",
    background: "color-mix(in srgb, #7c3aed, transparent 88%)",
  },
  iconAmber: {
    color: "#f59e0b",
    background: "color-mix(in srgb, #f59e0b, transparent 88%)",
  },
  iconRed: {
    color: "#ef4444",
    background: "color-mix(in srgb, #ef4444, transparent 88%)",
  },
  cardTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "var(--text-color)",
    margin: 0,
  },
  cardSubtitle: {
    fontSize: "12px",
    color: "var(--text-color)",
    opacity: 0.5,
    margin: 0,
  },
  cardBody: {
    padding: "24px",
  },
  createRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  },
  formInput: {
    flex: "1 1 300px",
    padding: "11px 16px",
    borderRadius: "10px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 85%)",
    background: "var(--body-color-less2)",
    color: "var(--text-color)",
    fontSize: "14px",
    outline: "none",
    transition: "border-color 0.2s ease",
    maxWidth: "400px",
  },
  btnPrimary: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 24px",
    borderRadius: "12px",
    border: "none",
    background: "var(--btn-color)",
    color: "#fff",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow:
      "0 2px 8px color-mix(in srgb, var(--btn-color), transparent 60%)",
  },
  btnDanger: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "9px 20px",
    borderRadius: "12px",
    border: "none",
    background: "#ef4444",
    color: "#fff",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 8px color-mix(in srgb, #ef4444, transparent 60%)",
  },
  btnDangerDisabled: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "9px 20px",
    borderRadius: "12px",
    border: "none",
    background: "color-mix(in srgb, #ef4444, transparent 60%)",
    color: "rgba(255,255,255,0.5)",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "not-allowed",
  },
  btnCancel: {
    padding: "10px 24px",
    borderRadius: "12px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 85%)",
    background: "transparent",
    color: "var(--text-color)",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
  },
  btnSmall: {
    padding: "6px 14px",
    borderRadius: "8px",
    border: "none",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  btnEdit: {
    background: "#3b82f6",
    color: "#fff",
  },
  btnDelete: {
    background: "#ef4444",
    color: "#fff",
  },
  // Generated key display
  generatedKeyCard: {
    marginTop: "20px",
    background: "var(--body-color-less2)",
    borderRadius: "12px",
    padding: "20px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 90%)",
  },
  generatedKeyLabel: {
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.6px",
    color: "var(--text-color)",
    opacity: 0.5,
    marginBottom: "8px",
  },
  generatedKeyRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "16px",
  },
  generatedKeyValue: {
    flex: 1,
    padding: "10px 14px",
    borderRadius: "8px",
    background: "var(--body-color-less)",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 90%)",
    fontFamily: "'SF Mono', 'Fira Code', 'Fira Mono', monospace",
    fontSize: "13px",
    color: "var(--text-color)",
    wordBreak: "break-all",
  },
  copyBtn: {
    padding: "8px 16px",
    borderRadius: "8px",
    border: "1px solid color-mix(in srgb, var(--btn-color), transparent 20%)",
    background: "var(--btn-color)",
    color: "#fff",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "all 0.2s ease",
  },
  // Table
  tableCard: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
    overflow: "hidden",
  },
  tableCardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 24px",
    borderBottom:
      "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
    flexWrap: "wrap",
    gap: "12px",
  },
  tableCardHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  tableWrapper: {
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    padding: "14px 20px",
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    color: "var(--text-color)",
    opacity: 0.5,
    borderBottom:
      "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
    textAlign: "left",
    whiteSpace: "nowrap",
  },
  td: {
    padding: "16px 20px",
    fontSize: "13px",
    color: "var(--text-color)",
    borderBottom:
      "1px solid color-mix(in srgb, var(--text-color), transparent 95%)",
    verticalAlign: "middle",
  },
  keyNameCell: {
    fontWeight: "600",
    fontSize: "14px",
  },
  monoCell: {
    fontFamily: "'SF Mono', 'Fira Code', 'Fira Mono', monospace",
    fontSize: "12px",
    maxWidth: "220px",
    wordBreak: "break-all",
    opacity: 0.8,
  },
  idBadge: {
    display: "inline-block",
    padding: "3px 10px",
    borderRadius: "8px",
    background: "color-mix(in srgb, var(--text-color), transparent 92%)",
    fontFamily: "'SF Mono', 'Fira Code', 'Fira Mono', monospace",
    fontSize: "12px",
    fontWeight: "500",
  },
  dateBadge: {
    fontSize: "12px",
    color: "var(--text-color)",
    opacity: 0.6,
    whiteSpace: "nowrap",
  },
  permBadge: (active) => ({
    display: "inline-block",
    padding: "3px 10px",
    borderRadius: "6px",
    fontSize: "11px",
    fontWeight: "600",
    marginRight: "4px",
    marginBottom: "4px",
    background: active
      ? "color-mix(in srgb, #10b981, transparent 88%)"
      : "color-mix(in srgb, var(--text-color), transparent 94%)",
    color: active ? "#10b981" : "var(--text-color)",
    opacity: active ? 1 : 0.4,
  }),
  ipBadge: {
    display: "inline-block",
    padding: "3px 10px",
    borderRadius: "6px",
    fontSize: "11px",
    fontWeight: "500",
    background: "color-mix(in srgb, #f59e0b, transparent 88%)",
    color: "#f59e0b",
    fontFamily: "'SF Mono', 'Fira Code', 'Fira Mono', monospace",
  },
  actionCell: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  emptyState: {
    textAlign: "center",
    padding: "60px 24px",
  },
  emptyIcon: {
    width: "64px",
    height: "64px",
    borderRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "28px",
    color: "var(--text-color)",
    opacity: 0.25,
    background: "color-mix(in srgb, var(--text-color), transparent 92%)",
    margin: "0 auto 16px",
  },
  emptyText: {
    fontSize: "15px",
    color: "var(--text-color)",
    opacity: 0.45,
    fontWeight: "500",
  },
  // Modal
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.6)",
    backdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1060,
    padding: "20px",
  },
  modalContent: {
    background: "var(--body-color-less)",
    borderRadius: "20px",
    width: "100%",
    maxWidth: "560px",
    maxHeight: "85vh",
    overflowY: "auto",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 90%)",
    boxShadow: "0 24px 80px rgba(0,0,0,0.3)",
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    padding: "24px 28px 20px",
    borderBottom:
      "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
  },
  modalIconBadge: (color) => ({
    width: "42px",
    height: "42px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    color: color,
    background: `color-mix(in srgb, ${color}, transparent 88%)`,
    flexShrink: 0,
  }),
  modalTitle: {
    fontSize: "18px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  modalSubtitle: {
    fontSize: "13px",
    color: "var(--text-color)",
    opacity: 0.5,
    margin: 0,
  },
  modalBody: {
    padding: "24px 28px",
  },
  modalFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "12px",
    padding: "20px 28px 24px",
    borderTop:
      "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
  },
  formGroup: {
    marginBottom: "18px",
  },
  formLabel: {
    display: "block",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "var(--text-color)",
    opacity: 0.6,
    marginBottom: "8px",
  },
  modalInput: {
    width: "100%",
    padding: "11px 16px",
    borderRadius: "10px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 85%)",
    background: "var(--body-color-less2)",
    color: "var(--text-color)",
    fontSize: "14px",
    outline: "none",
    transition: "border-color 0.2s ease",
    boxSizing: "border-box",
  },
  readOnlyValue: {
    padding: "10px 14px",
    borderRadius: "8px",
    background: "var(--body-color-less2)",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
    fontFamily: "'SF Mono', 'Fira Code', 'Fira Mono', monospace",
    fontSize: "13px",
    color: "var(--text-color)",
    wordBreak: "break-all",
    opacity: 0.8,
  },
  radioGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  radioOption: (selected) => ({
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "12px 16px",
    borderRadius: "10px",
    border: selected
      ? "1px solid var(--btn-color)"
      : "1px solid color-mix(in srgb, var(--text-color), transparent 90%)",
    background: selected
      ? "color-mix(in srgb, var(--btn-color), transparent 92%)"
      : "var(--body-color-less2)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  }),
  radioCircle: (selected) => ({
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    border: selected
      ? "5px solid var(--btn-color)"
      : "2px solid color-mix(in srgb, var(--text-color), transparent 70%)",
    flexShrink: 0,
    transition: "all 0.2s ease",
  }),
  radioLabel: {
    fontSize: "13px",
    fontWeight: "500",
    color: "var(--text-color)",
  },
  radioHint: {
    fontSize: "11px",
    color: "var(--text-color)",
    opacity: 0.5,
  },
  ipInput: {
    width: "100%",
    padding: "11px 16px",
    borderRadius: "10px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 85%)",
    background: "var(--body-color-less2)",
    color: "var(--text-color)",
    fontSize: "14px",
    outline: "none",
    boxSizing: "border-box",
  },
  ipHint: {
    fontSize: "11px",
    color: "var(--btn-color)",
    marginTop: "6px",
    fontWeight: "500",
  },
  ipTagList: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginTop: "12px",
  },
  ipTag: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px 12px",
    borderRadius: "8px",
    background: "color-mix(in srgb, var(--btn-color), transparent 88%)",
    color: "var(--btn-color)",
    fontFamily: "'SF Mono', 'Fira Code', 'Fira Mono', monospace",
    fontSize: "12px",
    fontWeight: "600",
  },
  ipTagRemove: {
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "700",
    opacity: 0.7,
    lineHeight: 1,
  },
  permCheckRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginTop: "4px",
  },
  permCheckItem: (checked) => ({
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 14px",
    borderRadius: "10px",
    border: checked
      ? "1px solid #10b981"
      : "1px solid color-mix(in srgb, var(--text-color), transparent 90%)",
    background: checked
      ? "color-mix(in srgb, #10b981, transparent 92%)"
      : "var(--body-color-less2)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontSize: "12px",
    fontWeight: "500",
    color: checked ? "#10b981" : "var(--text-color)",
    opacity: checked ? 1 : 0.6,
  }),
  checkbox: {
    width: "16px",
    height: "16px",
    accentColor: "#10b981",
    cursor: "pointer",
  },
  // 2FA Modal
  otpRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "8px",
  },
  otpInput: {
    flex: 1,
    padding: "11px 16px",
    borderRadius: "10px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 85%)",
    background: "var(--body-color-less2)",
    color: "var(--text-color)",
    fontSize: "14px",
    fontFamily: "'SF Mono', 'Fira Code', 'Fira Mono', monospace",
    letterSpacing: "2px",
    outline: "none",
    boxSizing: "border-box",
  },
  otpSendBtn: (disabled) => ({
    padding: "10px 18px",
    borderRadius: "10px",
    border: "none",
    background: disabled
      ? "color-mix(in srgb, var(--btn-color), transparent 60%)"
      : "var(--btn-color)",
    color: "#fff",
    fontSize: "13px",
    fontWeight: "600",
    cursor: disabled ? "not-allowed" : "pointer",
    whiteSpace: "nowrap",
    transition: "all 0.2s ease",
  }),
  timerText: {
    textAlign: "center",
    fontSize: "13px",
    color: "#f59e0b",
    fontWeight: "500",
    padding: "8px 0",
  },
};

const PERMISSION_LIST = [
  { label: "Dashboard", key: "isDashboard" },
  { label: "Products/Price", key: "isProductsPrice" },
  { label: "Create Payment", key: "isCreatePayment" },
  { label: "Onboarding", key: "isOnboarding" },
  { label: "Transactions", key: "isTransactions" },
  { label: "Settlements", key: "isSettlements" },
  { label: "Analytics", key: "isAnalytics" },
  { label: "Team", key: "isTeam" },
  { label: "Payment Setup", key: "isPaymentSetup" },
  { label: "Checkout Templates", key: "isCheckoutTemplates" },
  { label: "Limits", key: "isLimits" },
  { label: "Payment Tolerance", key: "isPaymentTolerance" },
  { label: "Developers", key: "isDevelopers" },
  { label: "Rewards", key: "isRewards" },
].filter((p) => !isTestMode || p.key !== "isTeam");

const RATE_LIMIT_TIERS_API = `${WEBSERVICE}/domain/rateLimitTiers`;

class ApiKeys extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      apitype: [],
      apikey: "",
      secretkey: "",
      apikeylist: [],
      ipRestrictStatus: 0,
      ipListTemp: [],
      twoFactorAPIKeyModal: false,
      newAPIKeyName: "",
      apiKey: "abc123xyz456",
      apiSecret: "secret789xyz321",
      permissions: {
        Read: true,
        Dashboard: false,
        "Payment Button": false,
        "RECURRING PAYMENT": false,
        "EMAIL BILLING": false,
        "HOSTED CATALOG": false,
        INSIGHTS: false,
      },
      showEditApiModal: false,
      selectedApiKey: null,
      twoFactorAPIKeyModalStatus: "",
      newApiKeyGen: "",
      newApiSecretKeyGen: "",
      deletePayload: {},
      showEmailOtpTimer: false,
      emailOtpTimerTxt: "",
      sendEmailOtpBtn: false,
      proceedEmailOtpBtn: true,
      sendEmailOtpFor2faBtn: false,
      permission: "",
      showEditSecret: false,
      showIncreaseRateLimitModal: false,
      selectedRateLimitApiKey: null,
      newRateLimitValue: "",
      newRateLimitTierId: "",
      currentRateLimit: 0,
      isIncreaseRequested: false,
      rateLimitTiers: [],
      rateLimitTierError: "",
    };

    this.emailOtpForTwoFaOff = React.createRef();
    this.gaCodeFor2faOff = React.createRef();
  }

  componentDidMount() {
    this.setState({ permission: currentPageAccess() });
    this.allApiTypeKey();
    this.getApiKeyList();
    this.getRateLimitTiers();

    if (localStorage.getItem("secstatuscheckForEmailOtpTimer") == "true") {
      this.startTimerForEmailOtp(localStorage.getItem("cdotpforapikey"));
      this.setState({
        secstatuscheckForEmailOtpTimer: true,
        sendEmailOtpFor2faBtn: true,
        sendEmailOtpBtn: true,
        showEmailOtpTimer: true,
        proceedEmailOtpBtn: false,
        emailOtpTimerTxt: localStorage.getItem("cdotpforapikey"),
      });
    } else {
      this.setState({
        secstatuscheckForEmailOtpTimer: false,
        sendEmailOtpBtn: false,
        proceedEmailOtpBtn: true,
      });
    }
  }

  componentWillUnmount() {
    if (this.downloadTimer) {
      clearInterval(this.downloadTimer);
    }
  }

  getRateLimitTiers = () => {
    axios
      .get(RATE_LIMIT_TIERS_API, {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "bearer " + getAuthToken(),
          UUID: getAuthUuid(),
        },
      })
      .then((response) => {
        const tiers = response.data.data || [];
        this.setState({ rateLimitTiers: tiers });
      })
      .catch((error) => {
        console.error("Error fetching rate limit tiers:", error);
      });
  };

  allApiTypeKey = () => {
    axios
      .get(`${WEBSERVICE}/apiKey/allApiType`, {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "bearer " + getAuthToken(),
          UUID: getAuthUuid(),
        },
      })
      .then((response) => {
        let apitype = response.data.apiTypeList;
        this.setState({ apitype });
      })
      .catch((error) => {
        console.error("Error fetching API types:", error);
      });
  };

  getApiKeyList = () => {
    const merchant_id = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    const merchant_uuid = getAuthUuid();

    axios
      .post(
        `${WEBSERVICE}/apiKey/getUserWiseApiKeyDetails`,
        { merchant_id, merchant_uuid },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "bearer " + getAuthToken(),
            UUID: getAuthUuid(),
          },
        }
      )
      .then((response) => {
        this.setState({
          apikeylist: response.data.api_keys || [],
          currentRateLimit: response.data.rateLimit || 0,
          isIncreaseRequested: response.data.isIncreaseRequested || 0,
        });
      })
      .catch((error) => {
        console.error("Error fetching API keys:", error);
      });
  };

  requestRateLimitIncrease = async () => {
    const merchant_id = localStorage.getItem(SITENAMEALIAS + "_merchant_id");

    if (
      !this.state.newRateLimitTierId ||
      this.state.newRateLimitTierId.trim() === ""
    ) {
      this.setState({ rateLimitTierError: "Please select a rate limit tier" });
      return;
    }

    const selectedTier = this.state.rateLimitTiers.find(
      (t) => t.id.toString() === this.state.newRateLimitTierId
    );
    if (!selectedTier) {
      this.setState({ rateLimitTierError: "Invalid tier selected" });
      return;
    }

    this.setState({ showLoader: true });

    try {
      const response = await fetch(
        `${WEBSERVICE}/apiKey/request/increaseRateLimit`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "bearer " + getAuthToken(),
            UUID: getAuthUuid(),
          },
          body: JSON.stringify({
            merchantId: parseInt(merchant_id),
            requestStatus: 1,
            newRateLimit: selectedTier.rateLimit,
          }),
        }
      );

      const result = await response.json();

      if (result.error?.error_data !== 0) {
        showToast("error", result.error?.error_message);
      } else {
        showToast("success", "Rate limit increase request submitted");
        this.setState({
          showIncreaseRateLimitModal: false,
          newRateLimitValue: "",
          newRateLimitTierId: "",
          rateLimitTierError: "",
        });
        this.getApiKeyList();
      }
    } catch (error) {
      console.error("Error requesting rate limit increase:", error);
      showToast("error", "Failed to submit rate limit increase request");
    } finally {
      this.setState({ showLoader: false });
    }
  };

  createAPIkey = () => {
    const merchant_id = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    const merchant_uuid = getAuthUuid();
    const keyName = this.state.newAPIKeyName;
    const securityCode = isTestMode ? "" : this.gaCodeFor2faOff.current.value;
    const emailOtp = this.emailOtpForTwoFaOff.current.value;

    axios
      .post(
        `${WEBSERVICE}/apiKey/generateKeys`,
        { merchant_id, merchant_uuid, keyName, securityCode, emailOtp },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "bearer " + getAuthToken(),
            UUID: getAuthUuid(),
          },
        }
      )
      .then((response) => {
        if (response.data.error?.error_data !== 0) {
          showToast(
            "error",
            response.data.error?.error_message || response.data.error?.error_msg
          );
        } else {
          showToast(
            "success",
            response.data.error?.error_message || response.data.error?.error_msg
          );
          this.setState({
            newApiKeyGen: response.data.apiKey,
            newApiSecretKeyGen: response.data.secretKey,
            twoFactorAPIKeyModal: false,
            _2faModalMounted: false,
          });
          this.getApiKeyList();
        }
      })
      .catch((error) => {
        console.error("Error creating API key:", error);
      });
  };

  openTwoFaModal = (status) => {
    this.setState({
      twoFactorAPIKeyModalStatus: status,
      twoFactorAPIKeyModal: true,
    }, () => {
      this.sendEmailFor2fa(true);
    });
  };

  handleAPICreate = () => {
    if (this.state.newAPIKeyName == "" || this.state.newAPIKeyName == null) {
      showToast("error", "Please add an API key name");
    } else {
      if (
        isTestMode ||
        localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") === "1"
      ) {
        this.openTwoFaModal("Create");
      } else {
        showToast("error", "Please turn on Google Authentication in Settings.");
      }
    }
  };
  handleAPIEdit = () => {
    const selected = this.state.selectedApiKey;
    const hasWrite = PERMISSION_LIST.some((p) => selected?.[p.key] === 2);

    if (hasWrite) {
      if (this.state.ipRestrictStatus !== 1) {
        showToast(
          "error",
          "You must restrict access to trusted IPs when any permission has Write access."
        );
        return;
      }
      const validIps = this.state.ipListTemp.filter((ip) => ip.trim() !== "");
      if (validIps.length === 0) {
        showToast(
          "error",
          "At least one trusted IP address is required for Write permissions."
        );
        return;
      }
    }

    if (
      isTestMode ||
      localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") === "1"
    ) {
      this.openTwoFaModal("Edit");
    } else {
      showToast("error", "Please turn on Google Authentication in Settings.");
    }
  };

  handleDeleteApiKey = (data) => {
    this.state.deletePayload = {
      id: data.id,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      merchant_uuid: getAuthUuid(),
      keyName: data.keyName,
      action: "DELETE",
      ipAddress: data.ipAddress,
      isRead: data.isRead,
      isDashboard: data.isDashboard,
      isPayments: data.isPayments,
      isPaymentButton: data.isPaymentButton,
      isRecurringPayment: data.isRecurringPayment,
      isEmailBilling: data.isEmailBilling,
      isHostedCatalog: data.isHostedCatalog,
      isInsights: data.isInsights,
    };

    if (
      isTestMode ||
      localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") === "1"
    ) {
      this.openTwoFaModal("Delete");
    } else {
      showToast("error", "Please turn on Google Authentication in Settings.");
    }
  };

  handleDeleteAll = () => {
    if (
      isTestMode ||
      localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") === "1"
    ) {
      this.openTwoFaModal("DeleteAll");
    } else {
      showToast("error", "Please turn on Google Authentication in Settings.");
    }
  };

  updateApiKey = async () => {
    const selected = this.state.selectedApiKey;

    const authObj = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      merchant_uuid: getAuthUuid(),
      id: selected.id,
      keyName: selected.keyName,
      apiKey: selected.apiKey,
      secretKey: selected.secretKey,
      securityCode: isTestMode ? "" : this.gaCodeFor2faOff.current.value,
      emailOtp: this.emailOtpForTwoFaOff.current.value,
      action: "UPDATE",
      // 0=no access, 1=Read, 2=Write
      isDashboard: selected.isDashboard ?? 0,
      isProductsPrice: selected.isProductsPrice ?? 0,
      isCreatePayment: selected.isCreatePayment ?? 0,
      isOnboarding: selected.isOnboarding ?? 0,
      isTransactions: selected.isTransactions ?? 0,
      isSettlements: selected.isSettlements ?? 0,
      isAnalytics: selected.isAnalytics ?? 0,
      isTeam: selected.isTeam ?? 0,
      isPaymentSetup: selected.isPaymentSetup ?? 0,
      isCheckoutTemplates: selected.isCheckoutTemplates ?? 0,
      isLimits: selected.isLimits ?? 0,
      isPaymentTolerance: selected.isPaymentTolerance ?? 0,
      isDevelopers: selected.isDevelopers ?? 0,
      isRewards: selected.isRewards ?? 0,
      ipAddress: this.state.ipListTemp.join(","),
    };
    try {
      const response = await fetch(WEBSERVICE + "/apiKey/updateKeys", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "bearer " + getAuthToken(),
          UUID: getAuthUuid(),
        },
        body: JSON.stringify(authObj),
      });

      const result = await response.json();
      this.setState({
        showEditApiModal: false,
        twoFactorAPIKeyModal: false,
        _2faModalMounted: false,
      });

      if (result.error?.error_data !== 0) {
        showToast("error", result.error?.error_message);
      } else {
        showToast("success", result.error?.error_message);
        this.getApiKeyList();
      }
    } catch (error) {
      console.error("API update failed:", error);
    }
  };

  deleteApiKeyById = async () => {
    this.state.deletePayload.securityCode = isTestMode ? "" : this.gaCodeFor2faOff.current.value;
    this.state.deletePayload.emailOtp = this.emailOtpForTwoFaOff.current.value;

    try {
      const response = await fetch(WEBSERVICE + "/apiKey/updateKeys", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "bearer " + getAuthToken(),
          UUID: getAuthUuid(),
        },
        body: JSON.stringify(this.state.deletePayload),
      });

      const result = await response.json();

      if (result.error?.error_data !== 0) {
        showToast("error", result.error?.error_message);
      } else {
        showToast("success", result.error?.error_message);
        this.setState({
          showEditApiModal: false,
          twoFactorAPIKeyModal: false,
          _2faModalMounted: false,
        });
        this.getApiKeyList();
      }
    } catch (error) {
      console.error("API update failed:", error);
    }
  };

  deleteApiKey = async () => {
    const merchant_id = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    const merchant_uuid = getAuthUuid();

    axios
      .post(
        `${WEBSERVICE}/apiKey/deleteAllApiKeys`,
        { merchant_id, merchant_uuid },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "bearer " + getAuthToken(),
            UUID: getAuthUuid(),
          },
        }
      )
      .then((res) => {
        let response = res.data.error;
        this.setState({
          showEditApiModal: false,
          twoFactorAPIKeyModal: false,
          _2faModalMounted: false,
        });

        if (response.error_data != 0) {
          showToast("error", response.error_message);
        } else {
          showToast("success", "API keys deleted successfully");
          this.getApiKeyList();
        }
      })
      .catch((error) => {
        console.error("Error fetching API keys:", error);
      });
  };

  handleDeleteAllAPIs = () => {
    showConfirm(
      "Delete All APIs",
      "Are you sure you want to delete all APIs?",
      "warning",
      () => {
        this.handleDeleteAll();
      }
    );
  };

  handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    showToast("success", "Copied");
  };

  sendEmailFor2fa = (isAutoSend = false) => {
    const auto = isAutoSend === true;
    if (this.state.sendEmailOtpFor2faBtn) {
      return;
    }
    this.setState({ sendEmailOtpFor2faBtn: true });
    let payload = {
      email: localStorage.getItem(SITENAMEALIAS + "_email"),
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    sendOtpForTwoFa(payload)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
            this.setState({ sendEmailOtpFor2faBtn: false });
          } else {
            showToast("success", "Otp sent to your email");
            this.setState({
              showEmailOtpTimer: true,
              proceedEmailOtpBtn: false,
              sendEmailOtpFor2faBtn: true,
            });
            localStorage.setItem("secstatuscheckForEmailOtpTimer", "true");
            let count = "120";
            localStorage.setItem("cdotpforapikey", count);
            this.startTimerForEmailOtp(count);
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false, sendEmailOtpFor2faBtn: false });
          if (!auto) showHttpError(err);
        }.bind(this)
      );
  };

  startTimerForEmailOtp = (i) => {
    let count = parseInt(i, 10);
    if (isNaN(count)) count = 120;

    if (this.downloadTimer) {
      clearInterval(this.downloadTimer);
      this.downloadTimer = null;
    }

    this.setState({ emailOtpTimerTxt: count });

    this.downloadTimer = setInterval(() => {
      if (count <= 1) {
        clearInterval(this.downloadTimer);
        this.downloadTimer = null;
        this.setState({
          secstatuscheckForEmailOtpTimer: false,
          showEmailOtpTimer: false,
          proceedEmailOtpBtn: true,
          sendEmailOtpFor2faBtn: false,
          sendEmailOtpBtn: false,
        });
        localStorage.setItem("secstatuscheckForEmailOtpTimer", "false");
        localStorage.setItem("cdotpforapikey", "");
        return;
      }
      count -= 1;
      localStorage.setItem("cdotpforapikey", count.toString());
      this.setState({
        emailOtpTimerTxt: count,
      });
    }, 1000);
  };

  render() {
    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={styles.pageWrapper}>
              {/* Page Header */}
              <PageHeader
                icon="mdi-key-variant"
                title="API Keys"
                subtitle="Create and manage your API keys and permissions"
              />

              {/* Create API Card */}
              <div style={styles.createCard}>
                <div style={{ ...styles.cardHeader, justifyContent: "space-between" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div
                      style={{ ...styles.cardHeaderIcon, ...styles.iconGreen }}
                    >
                      <i className="fa fa-plus-circle"></i>
                    </div>
                    <div>
                      <h5 style={styles.cardTitle}>Create New API Key</h5>
                      <p style={styles.cardSubtitle}>
                        Generate a new key for your integrations
                      </p>
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                    {[
                      { label: "Merchant ID", value: localStorage.getItem(SITENAMEALIAS + "_merchant_id") },
                      { label: "Broker ID", value: localStorage.getItem(SITENAMEALIAS + "_broker_id") },
                    ].map(({ label, value }) => (
                      <div key={label} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <div>
                          <div style={{ fontSize: "10px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px", color: "var(--text-color)", opacity: 0.45, marginBottom: "2px" }}>{label}</div>
                          <div style={{ fontFamily: "'SF Mono','Fira Code',monospace", fontSize: "13px", fontWeight: "500", color: "var(--text-color)" }}>{value || "—"}</div>
                        </div>
                        <button
                          className="api-copy-btn"
                          style={{ ...styles.copyBtn, padding: "6px 12px", fontSize: "11px" }}
                          onClick={() => this.handleCopy(value)}
                          onMouseEnter={(e) => { e.currentTarget.style.background = "color-mix(in srgb, var(--btn-color), black 15%)"; }}
                          onMouseLeave={(e) => { e.currentTarget.style.background = "var(--btn-color)"; }}
                        >
                          <i className="fa fa-copy"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
                <div style={styles.cardBody}>
                  <div style={styles.createRow}>
                    <input
                      type="text"
                      placeholder="Enter API Key name"
                      style={styles.formInput}
                      value={this.state.newAPIKeyName}
                      onChange={(e) =>
                        this.setState({ newAPIKeyName: e.target.value })
                      }
                      onFocus={(e) => {
                        e.target.style.borderColor = "var(--btn-color)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor =
                          "color-mix(in srgb, var(--text-color), transparent 85%)";
                      }}
                    />
                    <button
                      type="button"
                      style={styles.btnPrimary}
                      onClick={this.handleAPICreate}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-1px)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)";
                      }}
                    >
                      <i
                        className="fa fa-plus"
                        style={{ fontSize: "12px" }}
                      ></i>
                      Create
                    </button>
                  </div>

                  {/* Newly generated keys */}
                  {this.state.newApiKeyGen != "" && (
                    <div style={styles.generatedKeyCard}>
                      <div style={styles.generatedKeyLabel}>API Key</div>
                      <div style={styles.generatedKeyRow}>
                        <div style={styles.generatedKeyValue}>
                          {this.state.newApiKeyGen}
                        </div>
                        <button
                          className="api-copy-btn"
                          style={styles.copyBtn}
                          onClick={() =>
                            this.handleCopy(this.state.newApiKeyGen)
                          }
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "color-mix(in srgb, var(--btn-color), black 15%)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "var(--btn-color)";
                          }}
                        >
                          <i
                            className="fa fa-copy"
                            style={{ marginRight: "4px" }}
                          ></i>{" "}
                          Copy
                        </button>
                      </div>

                      <div style={styles.generatedKeyLabel}>API Secret Key</div>
                      <div
                        style={{ ...styles.generatedKeyRow, marginBottom: 0 }}
                      >
                        <div style={styles.generatedKeyValue}>
                          {this.state.newApiSecretKeyGen}
                        </div>
                        <button
                          className="api-copy-btn"
                          style={styles.copyBtn}
                          onClick={() =>
                            this.handleCopy(this.state.newApiSecretKeyGen)
                          }
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "color-mix(in srgb, var(--btn-color), black 15%)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "var(--btn-color)";
                          }}
                        >
                          <i
                            className="fa fa-copy"
                            style={{ marginRight: "4px" }}
                          ></i>{" "}
                          Copy
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* All API Keys Table */}
              <div style={styles.tableCard}>
                <div style={styles.tableCardHeader}>
                  <div style={styles.tableCardHeaderLeft}>
                    <div
                      style={{ ...styles.cardHeaderIcon, ...styles.iconBlue }}
                    >
                      <i className="fa fa-list"></i>
                    </div>
                    <div>
                      <h5 style={styles.cardTitle}>All API Keys</h5>
                      <p style={styles.cardSubtitle}>
                        {this.state.apikeylist.length}{" "}
                        {this.state.apikeylist.length === 1 ? "key" : "keys"}{" "}
                        configured
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        paddingRight: "12px",
                        borderRight:
                          "1px solid color-mix(in srgb, var(--text-color), transparent 90%)",
                      }}
                    >
                      <div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "var(--text-color)",
                            opacity: 0.6,
                            marginBottom: "4px",
                          }}
                        >
                          Current rate limit
                        </div>
                        <div
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "var(--text-color)",
                          }}
                        >
                          {this.state.currentRateLimit
                            ? `${this.state.currentRateLimit.toLocaleString()} req/hour`
                            : "Not set"}
                        </div>
                      </div>
                      <button
                        disabled={this.state.isIncreaseRequested === 1}
                        style={{
                          padding: "8px 16px",
                          borderRadius: "8px",
                          border: `1px solid ${
                            this.state.isIncreaseRequested === 1
                              ? "#cbd5e1"
                              : "#f59e0b"
                          }`,
                          background:
                            this.state.isIncreaseRequested === 1
                              ? "#cbd5e1"
                              : "#f59e0b",
                          color: "#fff",
                          fontSize: "12px",
                          fontWeight: "600",
                          cursor:
                            this.state.isIncreaseRequested === 1
                              ? "not-allowed"
                              : "pointer",
                          whiteSpace: "nowrap",
                          transition: "all 0.2s ease",
                        }}
                        onClick={() =>
                          this.setState({
                            showIncreaseRateLimitModal: true,
                            selectedRateLimitApiKey: this.state.apikeylist[0],
                            newRateLimitTierId: "",
                            rateLimitTierError: "",
                          })
                        }
                        onMouseEnter={(e) => {
                          if (this.state.isIncreaseRequested !== 1) {
                            e.currentTarget.style.background =
                              "color-mix(in srgb, #f59e0b, black 15%)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (this.state.isIncreaseRequested !== 1) {
                            e.currentTarget.style.background = "#f59e0b";
                          }
                        }}
                      >
                        <i
                          className={`fa ${
                            this.state.isIncreaseRequested === 1
                              ? "fa-check"
                              : "fa-arrow-up"
                          }`}
                          style={{ marginRight: "4px" }}
                        ></i>
                        {this.state.isIncreaseRequested === 1
                          ? "Already Requested"
                          : "Request Increase"}
                      </button>
                    </div>
                    {this.state.apikeylist.length > 0 ? (
                      <button
                        style={styles.btnDanger}
                        onClick={this.handleDeleteAllAPIs}
                        onMouseEnter={(e) => {
                          e.target.style.transform = "translateY(-1px)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = "translateY(0)";
                        }}
                      >
                        <i
                          className="fa fa-trash-alt"
                          style={{ fontSize: "12px" }}
                        ></i>
                        Delete All
                      </button>
                    ) : (
                      <button style={styles.btnDangerDisabled} disabled>
                        <i
                          className="fa fa-trash-alt"
                          style={{ fontSize: "12px" }}
                        ></i>
                        Delete All
                      </button>
                    )}
                  </div>
                </div>

                <div style={styles.tableWrapper}>
                  {this.state.apikeylist.length === 0 ? (
                    <div style={styles.emptyState}>
                      <div style={styles.emptyIcon}>
                        <i className="fa fa-key"></i>
                      </div>
                      <div style={styles.emptyText}>
                        No API keys created yet
                      </div>
                    </div>
                  ) : (
                    <table style={styles.table}>
                      <thead>
                        <tr>
                          <th style={styles.th}>Name</th>
                          <th style={styles.th}>ID</th>
                          <th style={styles.th}>Public Key</th>
                          <th style={styles.th}>Date</th>
                          <th style={styles.th}>Permissions</th>
                          <th style={styles.th}>IP Access</th>
                          <th style={styles.th}>Rate Limit</th>
                          <th style={{ ...styles.th, textAlign: "right" }}>
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.apikeylist.map((item) => (
                          <tr
                            key={item.id}
                            style={{ transition: "background 0.15s ease" }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background =
                                "color-mix(in srgb, var(--text-color), transparent 96%)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "transparent";
                            }}
                          >
                            <td style={{ ...styles.td, ...styles.keyNameCell }}>
                              {item.keyName}
                            </td>
                            <td style={styles.td}>
                              <span style={styles.idBadge}>{item.id}</span>
                            </td>
                            <td style={styles.td}>
                              <span style={styles.monoCell}>{item.apiKey}</span>
                            </td>
                            <td style={styles.td}>
                              <span style={styles.dateBadge}>
                                {item.createdOn}
                              </span>
                            </td>
                            <td style={styles.td}>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "5px",
                                }}
                              >
                                {PERMISSION_LIST.map(({ label, key }) => {
                                  const val = item[key] ?? 0;
                                  if (val === 0) return null;
                                  const isWrite = val === 2;
                                  return (
                                    <span
                                      key={key}
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "4px",
                                        padding: "3px 9px",
                                        borderRadius: "20px",
                                        fontSize: "11px",
                                        fontWeight: "500",
                                        whiteSpace: "nowrap",
                                        background: isWrite
                                          ? "rgba(139,92,246,0.12)"
                                          : "rgba(59,130,246,0.1)",
                                        border: isWrite
                                          ? "1px solid rgba(139,92,246,0.4)"
                                          : "1px solid rgba(59,130,246,0.3)",
                                        color: isWrite ? "#a78bfa" : "#60a5fa",
                                      }}
                                    >
                                      <i
                                        className={
                                          isWrite ? "fas fa-pen" : "fas fa-eye"
                                        }
                                        style={{ fontSize: "9px" }}
                                      ></i>
                                      {label}
                                      <span
                                        style={{
                                          fontSize: "9px",
                                          opacity: 0.75,
                                        }}
                                      >
                                        {isWrite ? "Write" : "Read"}
                                      </span>
                                    </span>
                                  );
                                })}
                              </div>
                            </td>
                            <td style={styles.td}>
                              {item.ipAddress ? (
                                <span style={styles.ipBadge}>
                                  {item.ipAddress}
                                </span>
                              ) : (
                                <span
                                  style={{ fontSize: "12px", opacity: 0.4 }}
                                >
                                  Unrestricted
                                </span>
                              )}
                            </td>
                            <td style={styles.td}>
                              {this.state.currentRateLimit ? (
                                <span
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "500",
                                    color: "var(--text-color)",
                                  }}
                                >
                                  {this.state.currentRateLimit.toLocaleString()}{" "}
                                  req/hr
                                </span>
                              ) : (
                                <span
                                  style={{ fontSize: "12px", opacity: 0.4 }}
                                >
                                  Not set
                                </span>
                              )}
                            </td>
                            <td style={{ ...styles.td, textAlign: "right" }}>
                              <div style={styles.actionCell}>
                                <button
                                  style={{
                                    ...styles.btnSmall,
                                    ...styles.btnEdit,
                                  }}
                                  onClick={() =>
                                    this.setState({
                                      showEditApiModal: true,
                                      selectedApiKey: item,
                                      ipRestrictStatus:
                                        item.ipAccess === "Unrestricted"
                                          ? 0
                                          : 1,
                                      ipListTemp: item.ipAddress
                                        ? item.ipAddress.split(",")
                                        : [],
                                      showEditSecret: false,
                                    })
                                  }
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background =
                                      "color-mix(in srgb, #3b82f6, black 15%)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "#3b82f6";
                                  }}
                                >
                                  <i
                                    className="fa fa-pen"
                                    style={{
                                      fontSize: "11px",
                                      marginRight: "4px",
                                    }}
                                  ></i>
                                  Edit
                                </button>
                                <button
                                  style={{
                                    ...styles.btnSmall,
                                    ...styles.btnDelete,
                                  }}
                                  onClick={() => this.handleDeleteApiKey(item)}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background =
                                      "color-mix(in srgb, #ef4444, black 15%)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "#ef4444";
                                  }}
                                >
                                  <i
                                    className="fa fa-trash"
                                    style={{
                                      fontSize: "11px",
                                      marginRight: "4px",
                                    }}
                                  ></i>
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>

            <Footer />
          </div>

          {/* Edit API Modal */}
          {this.state.showEditApiModal && (
            <div
              style={styles.modalOverlay}
              onClick={() => this.setState({ showEditApiModal: false })}
            >
              <div
                style={styles.modalContent}
                onClick={(e) => e.stopPropagation()}
              >
                <div style={styles.modalHeader}>
                  <div style={styles.modalIconBadge("#3b82f6")}>
                    <i className="fa fa-pen"></i>
                  </div>
                  <div>
                    <h5 style={styles.modalTitle}>Edit API Key</h5>
                    <p style={styles.modalSubtitle}>
                      Update permissions and IP restrictions
                    </p>
                  </div>
                </div>
                <div style={styles.modalBody}>
                  {/* API Name */}
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>API Name</label>
                    <input
                      type="text"
                      style={styles.modalInput}
                      value={this.state.selectedApiKey?.keyName || ""}
                      onChange={(e) =>
                        this.setState({
                          selectedApiKey: {
                            ...this.state.selectedApiKey,
                            keyName: e.target.value,
                          },
                        })
                      }
                      maxLength={30}
                      onFocus={(e) => {
                        e.target.style.borderColor = "var(--btn-color)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor =
                          "color-mix(in srgb, var(--text-color), transparent 85%)";
                      }}
                    />
                  </div>

                  {/* Public Key */}
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Public Key</label>
                    <div style={styles.readOnlyValue}>
                      {this.state.selectedApiKey?.apiKey}
                    </div>
                  </div>

                  {/* Secret Key */}
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Secret Key</label>
                    <div
                      style={{
                        ...styles.readOnlyValue,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "10px",
                      }}
                    >
                      <span style={{ flex: 1, wordBreak: "break-all" }}>
                        {this.state.showEditSecret
                          ? this.state.selectedApiKey?.secretKey || ""
                          : "*******************"}
                      </span>
                      {/* <button
                        type="button"
                        onClick={() => this.setState((prev) => ({ showEditSecret: !prev.showEditSecret }))}
                        title={this.state.showEditSecret ? "Hide secret key" : "Show secret key"}
                        style={{
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                          padding: "4px",
                          display: "flex",
                          alignItems: "center",
                          color: "var(--text-color)",
                          opacity: 0.8,
                        }}
                      >
                        {this.state.showEditSecret ? (
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.64 21.64 0 0 1 5.06-5.94M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a21.77 21.77 0 0 1-3.17 4.19M1 1l22 22" />
                            <path d="M14.12 14.12A3 3 0 1 1 9.88 9.88" />
                          </svg>
                        ) : (
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                            <circle cx="12" cy="12" r="3" />
                          </svg>
                        )}
                      </button> */}
                    </div>
                  </div>

                  {/* Permissions */}
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>API Permissions</label>
                    <div>
                      {PERMISSION_LIST.map(({ label, key }) => {
                        const val = this.state.selectedApiKey?.[key] ?? 0;
                        const isRead = val === 1;
                        const isWrite = val === 2;
                        return (
                          <div
                            key={key}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "10px 4px",
                              borderBottom:
                                "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "13px",
                                fontWeight: "500",
                                color: "var(--text-color)",
                              }}
                            >
                              {label}
                            </span>
                            <div style={{ display: "flex", gap: "20px" }}>
                              <label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  margin: 0,
                                  cursor: "pointer",
                                  fontSize: "13px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={isRead}
                                  style={styles.checkbox}
                                  onChange={(e) => {
                                    const newVal = e.target.checked ? 1 : 0;
                                    const hasWrite =
                                      PERMISSION_LIST.some(
                                        (p) =>
                                          p.key !== key &&
                                          (this.state.selectedApiKey?.[p.key] ??
                                            0) === 2
                                      ) ||
                                      (!e.target.checked && isWrite);
                                    this.setState((prev) => ({
                                      selectedApiKey: {
                                        ...prev.selectedApiKey,
                                        [key]: newVal,
                                      },
                                    }));
                                  }}
                                />
                                Read
                              </label>
                              <label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  margin: 0,
                                  cursor: "pointer",
                                  fontSize: "13px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={isWrite}
                                  style={styles.checkbox}
                                  onChange={(e) => {
                                    const newVal = e.target.checked ? 2 : 0;
                                    const updatedKey = {
                                      ...this.state.selectedApiKey,
                                      [key]: newVal,
                                    };
                                    const anyWrite = PERMISSION_LIST.some(
                                      (p) => (updatedKey[p.key] ?? 0) === 2
                                    );
                                    this.setState((prev) => ({
                                      selectedApiKey: {
                                        ...prev.selectedApiKey,
                                        [key]: newVal,
                                      },
                                      ipRestrictStatus: anyWrite
                                        ? 1
                                        : prev.ipRestrictStatus,
                                    }));
                                  }}
                                />
                                Write
                              </label>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* IP Restrictions */}
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>
                      IP Access Restrictions
                      {PERMISSION_LIST.some(
                        (p) => (this.state.selectedApiKey?.[p.key] ?? 0) === 2
                      ) && <span style={{ color: "#ef4444" }}> * </span>}
                      {PERMISSION_LIST.some(
                        (p) => (this.state.selectedApiKey?.[p.key] ?? 0) === 2
                      ) && (
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "400",
                            opacity: 0.6,
                            textTransform: "none",
                            letterSpacing: 0,
                          }}
                        >
                          Required for Write permissions
                        </span>
                      )}
                    </label>
                    <div style={styles.radioGroup}>
                      <div
                        style={{
                          ...styles.radioOption(
                            this.state.ipRestrictStatus === 0
                          ),
                          opacity: PERMISSION_LIST.some(
                            (p) =>
                              (this.state.selectedApiKey?.[p.key] ?? 0) === 2
                          )
                            ? 0.4
                            : 1,
                          pointerEvents: PERMISSION_LIST.some(
                            (p) =>
                              (this.state.selectedApiKey?.[p.key] ?? 0) === 2
                          )
                            ? "none"
                            : "auto",
                        }}
                        onClick={() => this.setState({ ipRestrictStatus: 0 })}
                      >
                        <div
                          style={styles.radioCircle(
                            this.state.ipRestrictStatus === 0
                          )}
                        ></div>
                        <div>
                          <div style={styles.radioLabel}>Unrestricted</div>
                          <div style={styles.radioHint}>
                            Less secure - allows access from any IP
                          </div>
                        </div>
                      </div>
                      <div
                        style={styles.radioOption(
                          this.state.ipRestrictStatus === 1
                        )}
                        onClick={() => this.setState({ ipRestrictStatus: 1 })}
                      >
                        <div
                          style={styles.radioCircle(
                            this.state.ipRestrictStatus === 1
                          )}
                        ></div>
                        <div>
                          <div style={styles.radioLabel}>
                            Restrict to trusted IPs
                          </div>
                          <div style={styles.radioHint}>
                            Recommended - only allow specific IPs
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* IP List */}
                  {this.state.ipRestrictStatus === 1 && (
                    <div style={styles.formGroup}>
                      <input
                        type="text"
                        style={styles.ipInput}
                        placeholder="Enter IP address and press Enter"
                        onFocus={(e) => {
                          e.target.style.borderColor = "var(--btn-color)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor =
                            "color-mix(in srgb, var(--text-color), transparent 85%)";
                        }}
                        onKeyUp={(e) => {
                          if (e.key === "Enter") {
                            const ip = e.target.value.trim();
                            if (ip && !this.state.ipListTemp.includes(ip)) {
                              this.setState((prevState) => ({
                                ipListTemp: [...prevState.ipListTemp, ip],
                              }));
                              e.target.value = "";
                            }
                          }
                        }}
                      />
                      <div style={styles.ipHint}>
                        <i
                          className="fa fa-info-circle"
                          style={{ marginRight: "4px" }}
                        ></i>
                        Enter the IP address and press Enter to add it. After
                        adding all required IPs, click Save Changes to confirm.
                      </div>
                      {this.state.ipListTemp.length > 0 && (
                        <div style={styles.ipTagList}>
                          {this.state.ipListTemp.map((ip) => (
                            <span key={ip} style={styles.ipTag}>
                              {ip}
                              <span
                                style={styles.ipTagRemove}
                                onClick={() =>
                                  this.setState((prev) => ({
                                    ipListTemp: prev.ipListTemp.filter(
                                      (i) => i !== ip
                                    ),
                                  }))
                                }
                              >
                                &times;
                              </span>
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div style={styles.modalFooter}>
                  <button
                    type="button"
                    style={styles.btnCancel}
                    onClick={() => this.setState({ showEditApiModal: false })}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    style={styles.btnPrimary}
                    onClick={this.handleAPIEdit}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                    }}
                  >
                    <i className="fa fa-save" style={{ fontSize: "12px" }}></i>
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Two Factor Authentication Modal */}
          {this.state.twoFactorAPIKeyModal && (
            <div
              style={styles.modalOverlay}
              onClick={() => {
                this.setState({
                  twoFactorAPIKeyModal: false,
                  _2faModalMounted: false,
                });
              }}
            >
              <div
                style={styles.modalContent}
                onClick={(e) => e.stopPropagation()}
              >
                <div style={styles.modalHeader}>
                  <div style={styles.modalIconBadge("#f59e0b")}>
                    <i className="fa fa-shield-alt"></i>
                  </div>
                  <div>
                    <h5 style={styles.modalTitle}>Security Authentication</h5>
                    <p style={styles.modalSubtitle}>
                      Verify your identity to proceed
                    </p>
                  </div>
                </div>
                <div style={styles.modalBody}>
                  {/* Email OTP */}
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Email OTP</label>
                    <div style={styles.otpRow}>
                      <input
                        type="number"
                        style={styles.otpInput}
                        placeholder="Enter OTP"
                        ref={this.emailOtpForTwoFaOff}
                      />
                      <button
                        type="button"
                        style={styles.otpSendBtn(
                          this.state.sendEmailOtpFor2faBtn
                        )}
                        onClick={this.sendEmailFor2fa}
                        disabled={this.state.sendEmailOtpFor2faBtn}
                      >
                        {this.state.sendEmailOtpFor2faBtn
                          ? "OTP Sent"
                          : "Send OTP"}
                      </button>
                    </div>
                    {this.state.showEmailOtpTimer && (
                      <div style={styles.timerText}>
                        <i
                          className="fa fa-clock"
                          style={{ marginRight: "6px" }}
                        ></i>
                        Resend OTP in {this.state.emailOtpTimerTxt}s
                      </div>
                    )}
                  </div>

                  {/* Google Auth */}
                  {!isTestMode && (
                    <div style={styles.formGroup}>
                      <label style={styles.formLabel}>
                        Google Authenticator Code
                      </label>
                      <div style={styles.otpRow}>
                        <input
                          type="number"
                          style={styles.otpInput}
                          placeholder="Enter 2FA code"
                          ref={this.gaCodeFor2faOff}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div style={styles.modalFooter}>
                  <button
                    type="button"
                    style={styles.btnCancel}
                    onClick={() => {
                      this.setState({
                        twoFactorAPIKeyModal: false,
                        _2faModalMounted: false,
                      });
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    style={styles.btnPrimary}
                    onClick={() => {
                      if (this.state.twoFactorAPIKeyModalStatus === "Create")
                        this.createAPIkey();
                      if (this.state.twoFactorAPIKeyModalStatus === "Edit")
                        this.updateApiKey();
                      if (this.state.twoFactorAPIKeyModalStatus === "Delete")
                        this.deleteApiKeyById();
                      if (this.state.twoFactorAPIKeyModalStatus === "DeleteAll")
                        this.deleteApiKey();
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                    }}
                  >
                    <i
                      className="fa fa-check-circle"
                      style={{ fontSize: "12px" }}
                    ></i>
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Increase Rate Limit Modal */}
          {this.state.showIncreaseRateLimitModal && (
            <div
              style={styles.modalOverlay}
              onClick={() =>
                this.setState({ showIncreaseRateLimitModal: false })
              }
            >
              <div
                style={styles.modalContent}
                onClick={(e) => e.stopPropagation()}
              >
                <div style={styles.modalHeader}>
                  <div style={styles.modalIconBadge("#f59e0b")}>
                    <i className="fa fa-arrow-up"></i>
                  </div>
                  <div>
                    <h5 style={styles.modalTitle}>Increase Rate Limit</h5>
                    <p style={styles.modalSubtitle}>
                      Request to increase your API rate limit
                    </p>
                  </div>
                </div>
                <div style={styles.modalBody}>
                  {/* Current Rate Limit */}
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Current Rate Limit</label>
                    <div style={styles.readOnlyValue}>
                      {this.state.currentRateLimit > 0
                        ? `${this.state.currentRateLimit.toLocaleString()} requests/hour`
                        : "Not set"}
                    </div>
                  </div>

                  {/* New Rate Limit Tier */}
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>
                      Select Rate Limit Tier{" "}
                      <span style={{ color: "#ef4444" }}>*</span>
                    </label>
                    <div style={{ position: "relative" }}>
                      <i
                        className="fa fa-tachometer-alt"
                        style={{
                          position: "absolute",
                          left: "13px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "15px",
                          color: "var(--text-color)",
                          opacity: 0.35,
                          pointerEvents: "none",
                          zIndex: 1,
                        }}
                      />
                      <select
                        value={this.state.newRateLimitTierId}
                        onChange={(e) => {
                          this.setState({
                            newRateLimitTierId: e.target.value,
                            rateLimitTierError: "",
                          });
                        }}
                        style={{
                          ...styles.modalInput,
                          paddingLeft: "38px",
                          paddingRight: "32px",
                          borderColor: this.state.rateLimitTierError
                            ? "#ef4444"
                            : "color-mix(in srgb, var(--text-color), transparent 85%)",
                          appearance: "none",
                          background:
                            'var(--body-color-less2) url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>\') no-repeat right 12px center',
                          backgroundSize: "18px",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "var(--btn-color)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = this.state
                            .rateLimitTierError
                            ? "#ef4444"
                            : "color-mix(in srgb, var(--text-color), transparent 85%)";
                        }}
                      >
                        <option value="">Choose a tier...</option>
                        {(this.state.rateLimitTiers || []).map((tier) => (
                          <option key={tier.id} value={tier.id}>
                            {tier.name} - {tier.rateLimit.toLocaleString()}/hr
                          </option>
                        ))}
                      </select>
                    </div>
                    {this.state.rateLimitTierError && (
                      <div
                        style={{
                          fontSize: "11px",
                          color: "#ef4444",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          marginTop: "6px",
                        }}
                      >
                        <i
                          className="fa fa-exclamation-circle"
                          style={{ fontSize: "12px" }}
                        />
                        {this.state.rateLimitTierError}
                      </div>
                    )}
                    {this.state.newRateLimitTierId && (
                      <div
                        style={{
                          fontSize: "11px",
                          color: "var(--text-color)",
                          opacity: 0.45,
                          marginTop: "6px",
                        }}
                      >
                        {this.state.rateLimitTiers?.find(
                          (t) =>
                            t.id.toString() === this.state.newRateLimitTierId
                        ) &&
                          `Selected: ${
                            this.state.rateLimitTiers.find(
                              (t) =>
                                t.id.toString() ===
                                this.state.newRateLimitTierId
                            ).name
                          } - ${this.state.rateLimitTiers
                            .find(
                              (t) =>
                                t.id.toString() ===
                                this.state.newRateLimitTierId
                            )
                            .rateLimit.toLocaleString()}/hr`}
                      </div>
                    )}
                  </div>

                  {/* Information */}
                  <div
                    style={{
                      padding: "12px 14px",
                      borderRadius: "8px",
                      background:
                        "color-mix(in srgb, #3b82f6, transparent 92%)",
                      border:
                        "1px solid color-mix(in srgb, #3b82f6, transparent 80%)",
                      fontSize: "12px",
                      color: "var(--text-color)",
                      opacity: 0.8,
                      marginBottom: "12px",
                    }}
                  >
                    <i
                      className="fa fa-info-circle"
                      style={{ marginRight: "6px", color: "#3b82f6" }}
                    ></i>
                    The rate limit is enforced at the merchant account level and
                    is shared across all API keys.
                  </div>
                </div>
                <div style={styles.modalFooter}>
                  <button
                    type="button"
                    style={styles.btnCancel}
                    onClick={() =>
                      this.setState({ showIncreaseRateLimitModal: false })
                    }
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    style={styles.btnPrimary}
                    onClick={this.requestRateLimitIncrease}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                    }}
                  >
                    <i className="fa fa-send" style={{ fontSize: "12px" }}></i>
                    Submit Request
                  </button>
                </div>
              </div>
            </div>
          )}

          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }
}

export default ApiKeys;
